<p>current-invoices-report works!</p>
